<template>
  <ModalPlus
    :show="show"
    :withButtons="false"
    :title="title"
    maxWidth="1100px"
    :onClose="() => $emit('close')"
  >
    <div class="pb-4 mt-6 border-none shared-table-container">
      <div class="shared-table-innermost-container">
        <table class="shared-table">
          <thead>
            <tr class="shared-table-headings border-t-1">
              <th
                v-for="(tHeading, index) in tableHeadings"
                :key="`heading-${index}`"
                class="cursor-default shared-table-headings-heading"
              >
                <div class="flex items-center justify-center">
                  {{ tHeading }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in tableData"
              :key="`referrals-data-${index}`"
              class="shared-table-cells"
            >
              <td class="py-4 shared-table-cells-cell">
                {{ (data && data.netsuite_name) || ' - ' }}
              </td>
              <td class="py-4 shared-table-cells-cell">
                {{ (data && data.serial_number) || ' - ' }}
              </td>
              <td class="py-4 shared-table-cells-cell">{{ (data && data.tier) || ' - ' }}</td>
              <td class="py-4 shared-table-cells-cell">{{ (data && data.qty) || ' - ' }}</td>
              <td class="py-4 shared-table-cells-cell">{{ (data && data.amount) || ' - ' }}</td>
              <td class="py-4 shared-table-cells-cell">
                {{ (data && formatDate(data.created_at)) || ' - ' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ModalPlus>
</template>

<script>
import { format, parseISO } from 'date-fns';

import ModalPlus from './ModalPlus';

export default {
  name: 'ModalReferralOrderDetails',
  components: { ModalPlus },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    tableHeadings: {
      type: Array,
      required: false,
      default: () => [],
    },
    tableData: {
      type: Array,
      required: false,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: 'Referral Payout Invoice Details',
    },
  },
  methods: {
    formatDate(date) {
      return format(parseISO(date), 'PPPppp');
    },
  },
};
</script>
